const salesGSMock ={
    "title": "Sales",
    "type": "Sales",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "ytd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ]
        }
    },
    subMenu: [
        {
          // NavigationItem
          title: 'Total',
        },
        {
          // NavigationItem
          title: 'BRAZIL',
        },
        {
          // NavigationItem
          title: 'SF',
        },
        {
          // NavigationItem
          title: 'BLB',
        },
        {
          // NavigationItem
          title: 'AMF',
        },
        {
          // NavigationItem
          title: 'OTH',
        },
    ],
}

const ebitdaGSMock = {
    "title": "EBITDA",
    "type": "EBITDA",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "ytd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ]
        }
    },
    subMenu: [
        {
          // NavigationItem
          title: 'Total',
        },
        {
          // NavigationItem
          title: 'BRAZIL',
        },
        {
          // NavigationItem
          title: 'SF',
        },
        {
          // NavigationItem
          title: 'BLB',
        },
        {
          // NavigationItem
          title: 'AMF',
        },
        {
          // NavigationItem
          title: 'OTH',
        },
    ],
}

const oiGSMock = {
    "title": "OI",
    "type": "OI",
    "navigation": {
        "type": "GraphNavigation",
        "nav": {
            "month": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "qtd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ],
            "ytd": [
                {
                    "title": "LY",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "C",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                },
                {
                    "title": "BGT",
                    "graph": {
                        "data": [
                            {
                                "title": "Total",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 170.0,
                                                "percent": 3.0
                                            },
                                            "compare": {
                                                "value": 165.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 173.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 183.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 218.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 261.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 234.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 200.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 224.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 205.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 182.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 140.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BRAZIL",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 43.0,
                                                "percent": 4.0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 34.0,
                                                "percent": -13.0
                                            },
                                            "compare": {
                                                "value": 39.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 50.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 57.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 64.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 70.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 80.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 77.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 62.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 42.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "SF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 105.0,
                                                "percent": 5.0
                                            },
                                            "compare": {
                                                "value": 100.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 73.0,
                                                "percent": -35.0
                                            },
                                            "compare": {
                                                "value": 112.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 134.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 130.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 131.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 114.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 104.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 101.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 102.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 89.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 79.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "BLB",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 23.0,
                                                "percent": 38.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 22.0,
                                                "percent": 15.0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 61.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 28.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 34.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 30.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "AMF",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 16.0,
                                                "percent": -6.0
                                            },
                                            "compare": {
                                                "value": 17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 32.0,
                                                "percent": 29.0
                                            },
                                            "compare": {
                                                "value": 25.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 22.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 41.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 40.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 23.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": 19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "title": "OTH",
                                "graph": {
                                    "columnType": "M",
                                    "data": [
                                        {
                                            "colName": "Jan",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": -17.0,
                                                "percent": -85.0
                                            },
                                            "compare": {
                                                "value": -9.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Feb",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 11.0,
                                                "percent": 191.0
                                            },
                                            "compare": {
                                                "value": -13.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": true,
                                            "isFuture": false,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Mar",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Apr",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -15.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "May",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jun",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -14.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Jul",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -17.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Aug",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -20.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Sep",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -31.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Oct",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -19.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Nov",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        },
                                        {
                                            "colName": "Dec",
                                            "colGroupName": 2023,
                                            "partial": null,
                                            "current": {
                                                "value": 0.0,
                                                "percent": 0
                                            },
                                            "compare": {
                                                "value": -18.0,
                                                "percent": null
                                            },
                                            "isPreliminary": false,
                                            "isDefault": false,
                                            "isFuture": true,
                                            "cif": null,
                                            "kmt": null
                                        }
                                    ]
                                },
                                "battery": [
                                    {
                                        "title": "Jan",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 4.0,
                                                "columns": [
                                                    43.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 5.0,
                                                "columns": [
                                                    105.0,
                                                    100.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 38.0,
                                                "columns": [
                                                    23.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": -6.0,
                                                "columns": [
                                                    16.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": -85.0,
                                                "columns": [
                                                    -17.0,
                                                    -9.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Feb",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": -13.0,
                                                "columns": [
                                                    34.0,
                                                    39.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": -35.0,
                                                "columns": [
                                                    73.0,
                                                    112.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 15.0,
                                                "columns": [
                                                    22.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 29.0,
                                                "columns": [
                                                    32.0,
                                                    25.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 191.0,
                                                "columns": [
                                                    11.0,
                                                    -13.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Mar",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    50.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    134.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Apr",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    57.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    130.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    13.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -15.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "May",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    131.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    61.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jun",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    64.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    114.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    41.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -14.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Jul",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    70.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    28.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    18.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -17.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Aug",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    104.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    40.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -20.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Sep",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    80.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    101.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    34.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    20.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -31.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Oct",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    77.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    102.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    22.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    23.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -19.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Nov",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    62.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    89.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    30.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "title": "Dec",
                                        "colNames": [
                                            "ACT",
                                            "LM"
                                        ],
                                        "columns": [
                                            {
                                                "title": "BRAZIL",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    42.0
                                                ]
                                            },
                                            {
                                                "title": "SF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    79.0
                                                ]
                                            },
                                            {
                                                "title": "BLB",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    17.0
                                                ]
                                            },
                                            {
                                                "title": "AMF",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    19.0
                                                ]
                                            },
                                            {
                                                "title": "OTH",
                                                "value": 0,
                                                "columns": [
                                                    0.0,
                                                    -18.0
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "isMainGraph": false
                    }
                }
            ]
        }
    },
    subMenu: [
        {
          // NavigationItem
          title: 'Total',
        },
        {
          // NavigationItem
          title: 'BRAZIL',
        },
        {
          // NavigationItem
          title: 'SF',
        },
        {
          // NavigationItem
          title: 'BLB',
        },
        {
          // NavigationItem
          title: 'AMF',
        },
        {
          // NavigationItem
          title: 'OTH',
        },
    ],
}

export const GSGraphsMock = [
    salesGSMock,
    ebitdaGSMock,
    oiGSMock
];